import { Platform } from 'react-native';
import NativePlayer from './Native';
import WebPlayer from './Web';

export type { LessonPlayerProps, LessonPlayerRef } from './types';

const LessonPlayer = Platform.OS === 'web' ? WebPlayer : NativePlayer;
export default LessonPlayer;
